import React, { useState, useEffect } from 'react';

const WhatsAppToggle = () => {
  const [isEnabled, setIsEnabled] = useState(true);
  const [welcomeMessage, setWelcomeMessage] = useState('नमस्ते {name}! आपकी inquiry के लिए धन्यवाद। हमारी team जल्दी ही आपसे संपर्क करेगी। 🙏');

  // Load settings from localStorage on component mount
  useEffect(() => {
    const savedSettings = localStorage.getItem('whatsappSettings');
    if (savedSettings) {
      const settings = JSON.parse(savedSettings);
      setIsEnabled(settings.welcomeMessageEnabled || false);
      setWelcomeMessage(settings.welcomeMessage || 'नमस्ते {name}! आपकी inquiry के लिए धन्यवाद। हमारी team जल्दी ही आपसे संपर्क करेगी। 🙏');
    }
  }, []);

  // Save settings to localStorage whenever they change
  const saveSettings = (enabled, message) => {
    const settings = {
      welcomeMessageEnabled: enabled,
      welcomeMessage: message,
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem('whatsappSettings', JSON.stringify(settings));
  };

  const handleToggle = () => {
    const newState = !isEnabled;
    setIsEnabled(newState);
    saveSettings(newState, welcomeMessage);
  };

  const handleMessageChange = (e) => {
    const newMessage = e.target.value;
    setWelcomeMessage(newMessage);
    saveSettings(isEnabled, newMessage);
  };

  const testMessage = async () => {
    const testPhone = prompt('Test के लिए phone number enter करें (10 digits):');
    if (testPhone && testPhone.length === 10 && /^\d{10}$/.test(testPhone)) {
      try {
        const response = await fetch('/api/whatsapp-simple/send-welcome', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            phoneNumber: testPhone,
            message: welcomeMessage.replace('{name}', 'Test User')
          })
        });

        const result = await response.json();
        if (result.success) {
          alert('✅ Test message sent successfully!');
        } else {
          alert('❌ Failed to send test message: ' + result.error);
        }
      } catch (error) {
        alert('❌ Error sending test message: ' + error.message);
      }
    } else {
      alert('❌ Please enter a valid 10-digit phone number');
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 max-w-2xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-800">WhatsApp Settings</h2>
        <div className="flex items-center space-x-3">
          <span className={`text-sm font-medium ${isEnabled ? 'text-green-600' : 'text-gray-500'}`}>
            {isEnabled ? 'ON' : 'OFF'}
          </span>
          <button
            onClick={handleToggle}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 ${
              isEnabled ? 'bg-green-600' : 'bg-gray-300'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ease-in-out ${
                isEnabled ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Welcome Message Status
          </label>
          <div className={`p-3 rounded-lg ${isEnabled ? 'bg-green-50 border border-green-200' : 'bg-gray-50 border border-gray-200'}`}>
            <p className="text-sm">
              {isEnabled 
                ? '✅ Welcome messages will be sent to new leads automatically' 
                : '❌ Welcome messages are disabled for new leads'
              }
            </p>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Welcome Message Template
          </label>
          <textarea
            value={welcomeMessage}
            onChange={handleMessageChange}
            disabled={!isEnabled}
            rows={4}
            className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent ${
              isEnabled ? 'border-gray-300 bg-white' : 'border-gray-200 bg-gray-50 text-gray-500'
            }`}
            placeholder="Enter your welcome message template..."
          />
          <p className="text-xs text-gray-500 mt-1">
            Use {'{name}'} placeholder for lead's name
          </p>
        </div>

        <div className="flex space-x-3">
          <button
            onClick={testMessage}
            disabled={!isEnabled}
            className={`px-4 py-2 rounded-lg font-medium transition-colors duration-200 ${
              isEnabled
                ? 'bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            📱 Test Message
          </button>
          
          <div className="flex-1 text-right">
            <span className="text-xs text-gray-500">
              Settings auto-saved
            </span>
          </div>
        </div>
      </div>

      <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <h3 className="text-sm font-medium text-blue-800 mb-2">📋 How it works:</h3>
        <ul className="text-xs text-blue-700 space-y-1">
          <li>• Toggle ON/OFF to enable/disable welcome messages</li>
          <li>• Messages are sent automatically when new leads are created</li>
          <li>• Only valid 10-digit phone numbers receive messages</li>
          <li>• Settings are saved automatically</li>
          <li>• Use Test Message to verify functionality</li>
        </ul>
      </div>
    </div>
  );
};

export default WhatsAppToggle;
